import store from '@/store/store.js'

export default timeBlock => {
  return {...timeBlock, ...{
    mode_name: getModeName(timeBlock)
  }}
}

const getModeName = (timeBlock) => {
  let child = store.getters['children/getById'](timeBlock.user_id)

  if (!child) {
    return null
  }

  let mode = child.modes.find(mode => mode.id === timeBlock.mode_id)

  if (!mode) {
    return null
  }

  return mode.name
}
